import { axios, API, SendRequest } from '@/imports-files/pages/clients/jobs/job';

export class JobListing extends SendRequest {
    async getJobListingData(params) 
    {
        try 
        {    
            const result = await axios.get(API.admins.dashboard.clients.jobs.GET_JOBS_LIST,
              {
                params: params,
                headers: this.customHeaderJSON()
              },
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON()
            );
        
          return result;
        } 
        catch (error) 
        {
          return error;
        }
    }

    async failedJobBoardList(jobId) 
    {
        try 
        {
              const result = await axios.get(API.admins.dashboard.clients.jobs.FAILED_JOB_BOARDS.replace('$job_id', jobId),
              {
                headers: this.customHeaderJSON()
              },
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
          
          return result;
        } 
        catch (error) 
        {
          return error;
        }
    }

    async retryJobsOnJobBoardService(integrations_ids, jobId) 
    {
        try 
        {
              const result = await axios.post(API.admins.dashboard.clients.jobs.RETRY_JOB_BOARD.replace('$job_id', jobId),
              {integration_ids: integrations_ids},
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());

          return result;
        } 
        catch (error) 
        {
          return error;
        }
    }


    async dismissJobsOnJobBoardService(integrations_ids, jobId, discard_all) 
    {
        try 
        {
              const result = await axios.delete(API.admins.dashboard.clients.jobs.DISMISS_JOB_BOARD.replace('$job_id', jobId),
              {
                params: {integration_ids: integrations_ids, discard_all: discard_all},
                headers: this.customHeaderJSON()
              },
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
        
          return result;
        } 
        catch (error) 
        {
          return error;
        }
    }

    async getUserByNameOrEmail(params) {
      try {
        const result = await axios.get( API.client.jobs.GET_AGENCY_USERS,
          {
            params: params,
            headers: this.customHeaderJSON()
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
        return result;
      } 
      catch (error) {
        return error;
      }
    }
}
